import { Chip, ChipProps } from "@mui/material";
import { Article, Campaign, Group } from "@mui/icons-material";
import { EntityType } from "../types";


interface EntityTypeChipProps extends Omit<ChipProps, "icon" | "label"> {
  type: EntityType;
  label?: string;
  useAdSetLabel?: boolean;
  color?: ChipProps["color"];
}

function EntityTypeChip({
  type,
  label,
  useAdSetLabel = true,
  color,
  ...chipProps
}: EntityTypeChipProps) {
  const getTypeIcon = () => {
    switch (type) {
      case EntityType.CAMPAIGN:
        return <Campaign fontSize="small" />;
      case EntityType.AD_GROUP:
        return <Group fontSize="small" />;
      case EntityType.AD:
        return <Article fontSize="small" />;
    }
  };

  const getTypeColor = (): ChipProps["color"] => {
    if (color) return color; // Use provided color if specified

    switch (type) {
      case EntityType.CAMPAIGN:
        return "warning";
      case EntityType.AD_GROUP:
        return "secondary";
      case EntityType.AD:
        return "primary";
    }
  };

  const getTypeLabel = () => {
    if (label) return label;

    switch (type) {
      case EntityType.CAMPAIGN:
        return "Campaign";
      case EntityType.AD_GROUP:
        return useAdSetLabel ? "Ad Set" : "Ad Group";
      case EntityType.AD:
        return "Ad";
    }
  };

  return (
    <Chip
      icon={getTypeIcon()}
      label={getTypeLabel()}
      color={getTypeColor()}
      size="small"
      {...chipProps}
    />
  );
}

export default EntityTypeChip;

